import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SimplebarAngularModule } from 'simplebar-angular';
import { ChatComponent } from './chat.component';
import { ChatAuthImageDirective } from './directives/chat-auth-image.directive';
import { ChatIconComponent } from './components/chat-icon/chat-icon.component';
import { ChatAvatarComponent } from './components/chat-avatar/chat-avatar.component';
import { ChatConversationItemComponent } from './components/chat-conversation-item/chat-conversation-item.component';
import { ChatConversationListComponent } from './components/chat-conversation-list/chat-conversation-list.component';
import { ChatThreadHeaderComponent } from './components/chat-thread-header/chat-thread-header.component';
import { ChatDaySeparatorComponent } from './components/chat-day-separator/chat-day-separator.component';
import { ChatMessageComponent } from './components/chat-message/chat-message.component';
import { ChatPropertyCardComponent } from './components/chat-property-card/chat-property-card.component';
import { ChatThreadComponent } from './components/chat-thread/chat-thread.component';
import { ChatComposerComponent } from './components/chat-composer/chat-composer.component';
import { ChatEmojiPickerComponent } from './components/chat-emoji-picker/chat-emoji-picker.component';
import { ChatConnectionBannerComponent } from './components/chat-connection-banner/chat-connection-banner.component';
import { ChatEmptyStateComponent } from './components/chat-empty-state/chat-empty-state.component';
import { ChatAssignBannerComponent } from './components/chat-assign-banner/chat-assign-banner.component';
import { ChatInvitesComponent } from './components/chat-invites/chat-invites.component';
import { ChatColleaguePickerComponent } from './components/chat-colleague-picker/chat-colleague-picker.component';
import { ChatSupervisionComponent } from './components/chat-supervision/chat-supervision.component';
import { ChatPropertyPickerComponent } from './components/chat-property-picker/chat-property-picker.component';
import { ChatAssignPanelComponent } from './components/chat-assign-panel/chat-assign-panel.component';
import { ChatDetailsPanelComponent } from './components/chat-details-panel/chat-details-panel.component';
import { ChatVisitRequestCardComponent } from './components/chat-visit-request-card/chat-visit-request-card.component';
import { ChatVisitCardComponent } from './components/chat-visit-card/chat-visit-card.component';
import { ChatVisitFormCardComponent } from './components/chat-visit-form-card/chat-visit-form-card.component';
import { ChatQualificationCardComponent } from './components/chat-qualification-card/chat-qualification-card.component';
import { ChatProposalCardComponent } from './components/chat-proposal-card/chat-proposal-card.component';
import { ChatNextStepComponent } from './components/chat-next-step/chat-next-step.component';
import { ChatAudioPlayerComponent } from './components/chat-audio-player/chat-audio-player.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ChatSettingsComponent } from './settings/chat-settings.component';
import { RouterModule } from '@angular/router';

/**
 * Tudo o que compõe o chat, SEM rotas: é importado pela página (`ChatModule`,
 * lazy em `/chat`) e pelo balão flutuante (`ChatLauncherModule`, no layout).
 * Um módulo com `RouterModule.forChild` não pode ser importado no layout sem
 * registar as suas rotas na raiz; por isso as rotas ficam só no ChatModule.
 *
 * Dentro da conversa: CommonModule, o router (para os `routerLink` da ficha do
 * imóvel e do negócio), `ngbTooltip` nos botões de ícone e `ngx-simplebar`.
 * FormsModule e NgSelectModule servem os modais e a página de definições;
 * SharedModule traz o modal de propostas do CRM (app-proposal-modal).
 */
@NgModule({
  declarations: [
    ChatComponent,
    ChatSettingsComponent,
    ChatAuthImageDirective,
    ChatIconComponent,
    ChatAvatarComponent,
    ChatConversationItemComponent,
    ChatConversationListComponent,
    ChatThreadHeaderComponent,
    ChatDaySeparatorComponent,
    ChatMessageComponent,
    ChatPropertyCardComponent,
    ChatThreadComponent,
    ChatComposerComponent,
    ChatEmojiPickerComponent,
    ChatConnectionBannerComponent,
    ChatEmptyStateComponent,
    ChatAssignBannerComponent,
    ChatInvitesComponent,
    ChatColleaguePickerComponent,
    ChatSupervisionComponent,
    ChatPropertyPickerComponent,
    ChatAssignPanelComponent,
    ChatDetailsPanelComponent,
    ChatVisitRequestCardComponent,
    ChatVisitCardComponent,
    ChatNextStepComponent,
    ChatAudioPlayerComponent,
    ChatVisitFormCardComponent,
    ChatQualificationCardComponent,
    ChatProposalCardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    NgbTooltipModule,
    SimplebarAngularModule,
    SharedModule
  ],
  // ChatIconComponent / ChatAvatarComponent: o balão flutuante (launcher) desenha os seus
  // botões e o aviso de mensagem nova com os mesmos ícones e avatares.
  exports: [ChatComponent, ChatSettingsComponent, ChatIconComponent, ChatAvatarComponent]
})
export class ChatCoreModule { }
